import Icon from './Icon.tsx';
import { ComposedIconProps } from './Icon.tsx';
import url from '@assets/images/triple_dot.svg';

const TripleDotIcon = ({ icon = url, ...rest }: ComposedIconProps) => {
  return <Icon icon={icon} {...rest} />;
};

export default TripleDotIcon;
